import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';
import JobHelper from 'utils/jobHelper';
import withRouterHooks from 'utils/routerHelper';

const JobTypePage = props => (
  <Components.Form.MobileCoreLayout
    header={(
      <Components.Mobile.NavigationBar
        leftButton={Components.Mobile.NavigationBar.buttonConst.CLOSE}
        onLeftButtonClick={() => props.navigate('/jobs')}
        title={(
          <Components.Form.MobileTitle>
            <Components.Form.MobileTitle.Item isHighlighted key="title-job-info">
              {props.strings.Job.form.jobType.newJobInfo}
            </Components.Form.MobileTitle.Item>
            <Components.Form.MobileTitle.Item key="title-task-info">
              {props.strings.Job.form.jobType.newTaskInfo}
            </Components.Form.MobileTitle.Item>
          </Components.Form.MobileTitle>
        )}
      />
    )}
  >
    <Components.Form.Block fontWeight="BOLD" level={0}>
      {props.strings.Job.form.jobType.pickJobType}
    </Components.Form.Block>

    <Components.Form.Divider />

    <Components.Form.BoxRadio
      onClick={() => {
        props.onFormChange('job_type', 'delivery');
        props.setPage(JobHelper.PageConstants.JOB_DETAIL_EDIT);
      }}
    >
      <span className="vf-job__mobile-new-form__option-title">
        {Utils.Formatter.capitalizeFirstLetter(props.strings.Job.constants.delivery)}
      </span>
      <img alt="delivery" className="img-responsive" src="/assets/images/job_type_delivery.jpg" />
    </Components.Form.BoxRadio>
    <Components.Form.BoxRadio
      onClick={() => {
        props.onFormChange('job_type', 'pickup');
        props.setPage(JobHelper.PageConstants.JOB_DETAIL_EDIT);
      }}
    >
      <span className="vf-job__mobile-new-form__option-title">
        {Utils.Formatter.capitalizeFirstLetter(props.strings.Job.constants.pickup)}
      </span>
      <img alt="pickup" className="img-responsive" src="/assets/images/job_type_pickup.jpg" />
    </Components.Form.BoxRadio>
    <Components.Form.BoxRadio
      onClick={() => {
        props.onFormChange('job_type', 'p2p');
        props.setPage(JobHelper.PageConstants.JOB_DETAIL_EDIT);
      }}
    >
      <span className="vf-job__mobile-new-form__option-title">
        {Utils.Formatter.capitalizeFirstLetter(props.strings.Job.constants.pointToPoint)}
      </span>
      <img alt="point-to-point" className="img-responsive" src="/assets/images/job_type_p2p.jpg" />
    </Components.Form.BoxRadio>
  </Components.Form.MobileCoreLayout>
);

JobTypePage.propTypes = {
  navigate: PropTypes.func.isRequired,
  onFormChange: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      constants: PropTypes.shape({
        delivery: PropTypes.string,
        pickup: PropTypes.string,
        pointToPoint: PropTypes.string,
      }),
      form: PropTypes.shape({
        jobType: PropTypes.shape({
          newJobInfo: PropTypes.string,
          newTaskInfo: PropTypes.string,
          pickJobType: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

export default translate('')(withRouterHooks(JobTypePage));
